import { useMemo } from "react";

const StatusFilter = ({ selected, onChange, applications, layout = 'horizontal' }) => {
    const statuses = ['all', 'submitted', 'under_review', 'shortlisted', 'interview', 'offer_extended', 'hired', 'rejected'];
    
    const counts = useMemo(() => {
        const initialCounts = { all: applications.length };
        statuses.slice(1).forEach(s => {
            initialCounts[s] = applications.filter(app => app.status === s).length;
        });
        return initialCounts;
    }, [applications]);

    const getStatusDisplay = (status) => {
        const statusMap = {
            all: 'All',
            submitted: 'Submitted',
            under_review: 'Review',
            shortlisted: 'Shortlisted',
            interview: 'Interview',
            offer_extended: 'Offer',
            hired: 'Hired',
            rejected: 'Rejected'
        };
        return statusMap[status] || status;
    };

    // Vertical layout for mobile modal
    if (layout === 'vertical') {
        return (
            <div className="space-y-2">
                {statuses.map(status => (
                    <button
                        key={status}
                        onClick={() => onChange(status)}
                        className={`w-full flex items-center justify-between p-3 rounded-lg border-2 transition-all duration-200 ${
                            selected === status 
                                ? 'border-primary-500 bg-primary-50 text-primary-700' 
                                : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        <div className="flex items-center">
                            {selected === status && (
                                <Check className="w-4 h-4 mr-3 text-primary-600" />
                            )}
                            <span className={`font-medium ${selected === status ? 'text-primary-700' : 'text-gray-700'}`}>
                                {getStatusDisplay(status)}
                            </span>
                        </div>
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                            selected === status 
                                ? 'bg-primary-100 text-primary-700' 
                                : 'bg-gray-100 text-gray-600'
                        }`}>
                            {counts[status]}
                        </span>
                    </button>
                ))}
            </div>
        );
    }

    // Tablet layout - Compact horizontal with scroll
    if (layout === 'tablet') {
        return (
            <div className="flex items-center p-1 bg-gray-100 rounded-lg overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                {statuses.map(status => (
                    <button
                        key={status}
                        onClick={() => onChange(status)}
                        className={`flex-shrink-0 px-3 py-2 text-xs font-semibold rounded-md transition-all duration-200 min-w-[80px] text-center ${
                            selected === status 
                                ? 'bg-white text-primary-600 shadow-sm' 
                                : 'text-gray-600 hover:bg-gray-200'
                        }`}
                    >
                        <div>{getStatusDisplay(status)}</div>
                        <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                            selected === status 
                                ? 'bg-primary-100 text-primary-700' 
                                : 'bg-gray-300 text-gray-700'
                        }`}>
                            {counts[status]}
                        </span>
                    </button>
                ))}
            </div>
        );
    }

    // Horizontal layout for desktop
    return (
        <div className="flex items-center p-1 bg-gray-100 rounded-lg overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
            {statuses.map(status => (
                <button
                    key={status}
                    onClick={() => onChange(status)}
                    className={`flex-shrink-0 px-4 py-2 text-sm font-semibold rounded-md transition-all duration-200 min-w-max ${
                        selected === status 
                            ? 'bg-white text-primary-600 shadow-sm' 
                            : 'text-gray-600 hover:bg-gray-200'
                    }`}
                >
                    {getStatusDisplay(status)}
                    <span className={`ml-2 text-xs px-1.5 py-0.5 rounded-full ${
                        selected === status 
                            ? 'bg-primary-100 text-primary-700' 
                            : 'bg-gray-300 text-gray-700'
                    }`}>
                        {counts[status]}
                    </span>
                </button>
            ))}
        </div>
    );
};

export default StatusFilter;